import React, { FC } from 'react'
import { motion } from 'framer-motion'

interface ERPKeyFeaturesProps {
    erpSoftwareData: any
}

const ERPKeyFeatures: FC<ERPKeyFeaturesProps> = ({ erpSoftwareData }) => {
    return (
        <div className=''>
            <div className='mt-10 md:mt-20 relative px-4 sm:px-8 md:px-16 lg:px-24 overflow-x-clip grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8'>
                {erpSoftwareData.ERPSoftwareFeatureList.map((service: any, idx: number) => {
                    return (
                        <motion.div className='group p-[1px] rounded-2xl'
                            initial={{
                                backgroundImage: 'none'
                            }}
                            whileHover={{
                                backgroundImage: `linear-gradient(156deg, ${service.bgColor} -38.83%, ${service.bgColor}00 100.93%)`,
                                scale: 1.05,
                                transition: { duration: 0.3 }
                            }}>
                            <div

                                key={idx} className={`border border-darkGreyPrimary bg-blackDark rounded-2xl p-4 sm:p-6 md:p-8 bg-gradient-to-br from-transparent via-transparent to-[${service.arrowColor}]`}>
                                <div className={`font-bold text-lg sm:text-xl pb-4 flex gap-2 border-b border-[#373737] group-hover:border-${service.bgColor}`}>
                                    <div>{service.title}</div>
                                </div>
                                <ul className='list-disc gap-2 flex flex-col mt-4'>
                                    {service.list.map((serv: any, idx: any) => {
                                        return (
                                            <li key={idx} className='text-[#E0E0E0] ml-6'>{serv.title}</li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </motion.div>
                    )
                })}
            </div>
        </div >
    )
}

export default ERPKeyFeatures
